import React from "react";
import {
  FaReact,
  FaHandPointRight,
  FaDatabase,
  FaMapMarkerAlt,
  FaEnvelope,
  FaDownload,
  FaPhoneAlt,
  FaNodeJs,
  FaTools,
} from "react-icons/fa";
import { SiRubyonrails } from "react-icons/si";

const data = {
  homeDetails:
    "Développeur Full Stack passionné par la création de sites web et applications mobile de qualité supérieur et fonctionnels.",
  homeTitle: "Bienvenue sur mon portfolio personnel",
  projectTitle: "Projets",
  technoTitle: "Technologies",
  download: <FaDownload />,
  technoInfo:
    "J'ai une large gamme de compétences dans le domaine du développement web. J'ai de l'expérience dans la création de sites web et applications mobiles en utilisant HTML, CSS, JavaScript, React,React Native, Node.js, Express, MongoDB, MySQL et bien plus.",
  titleAbout: "À propos de moi",
  infoAbout:
    "Je suis Mwafrika Josué, un développeur de logiciels spécialisé dans diverses technologies. Je crée des applications web, des applications mobiles et des sites web attrayants pour les entreprises. J'aime me plonger dans des problèmes difficiles ainsi que d'apprendre de nouvelles langues et technologies.",
  imageAbout:
    "https://res.cloudinary.com/ujuzi/image/upload/v1653783195/mes%20documents/IMG_4892_gqppaj.jpg",
  cards: [
    {
      id: 1,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1670286381/Kevent/huntify_iw4jnf.png",
      alt: "react",
      title: "Huntify",
      technologies: ["MERN Stack", "Context API", "Styled-components"],
      info: "Huntify suit vos candidatures d'emploi et organise votre recherche d'emploi, le tout en un seul endroit. Fini les feuilles de calcul, les e-mails perdus et les candidatures d'emploi perdues.",
      code: "https://github.com/mwafrika/jobifyMev2",
      live: "https://huntify.netlify.app",
    },
    {
      id: 2,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1650097658/portfolio_images/kevent_n9ilbw.png",
      alt: "react",
      title: "Kevent",
      technologies: ["React", "TypeScript", "Redux", "Tailwind", "Node.js"],
      info: "Kevent est un logiciel de tourisme complet qui vous aide à trouver les meilleurs endroits à visiter dans votre région en fonction de vos préférences.",
      code: "https://github.com/mwafrika/kevent-web-second",
      live: "https://www.kevent-rdc.com/",
    },
    {
      id: 3,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1650092446/portfolio_images/FireShot_Capture_008_-_CMS_Blog_-_blog-with-cms.vercel.app_w3pkph.png",
      alt: "react",
      title: "GraphCMS",
      technologies: ["NextJS", "Tailwind CSS", "GraphQL", "GraphCMS"],
      info: "Un projet de blog avec des articles en Markdown, des informations sur l'auteur, des commentaires et bien plus encore. Cette application de blog CMS est entièrement responsive.",
      code: "https://github.com/mwafrika/GraphCMS-Blog",
      live: "https://blog-with-cms.vercel.app/",
    },
    {
      id: 4,
      icon: <SiRubyonrails />,
      image:
        "https://www.ecranlarge.com/uploads/image/001/350/walker-texas-ranger-photo-chuck-norris-1350724.JPG",
      alt: "React Native",
      title: "Chuck Noris App",
      technologies: ["React Native", "TypeScript", "Styled-component"],
      info: "Une application qui affiche les blagues les plus récentes et aléatoires de Chuck Norris en fonction des catégories disponibles.",
      code: "https://github.com/mwafrika/chuck-test-sovetech",
      live: "https://res.cloudinary.com/ujuzi/video/upload/v1660853712/XRecorder_18082022_215959_lrkth0.mp4",
    },
    {
      id: 5,
      icon: <FaReact />,
      image: "https://i.ibb.co/BK1Hn0x/Screenshot-2022-08-08-at-4-05-48-PM.png",
      alt: "react",
      title: "Page de destination",
      technologies: ["React", "Tailwind", "Vite"],
      info: "Un site web moderne complet (page de destination) utilisant React, TailwindCSS et Vite",
      code: "https://github.com/mwafrika/Modern-landing-page",
      live: "https://modern-landing-page2.netlify.app/",
    },
    {
      id: 6,
      icon: <FaReact />,
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1653778062/mes%20documents/space-traveller_uwn1w3.png",
      alt: "react",
      title: "Space Traveller Hub",
      technologies: ["React", "redux-thunk", "CSS-module"],
      info: "Une application web qui affiche des données en temps réel de l'API SpaceX. Les utilisateurs peuvent réserver des fusées et des dragons et rejoindre des missions spatiales sélectionnées. Vous pouvez également annuler les réservations souhaitées.",
      code: "https://github.com/mwafrika/space_traveller_hub",
      live: "https://space-traveller.netlify.app/",
    },
  ],
  technologies: [
    {
      id: 1,
      icon: <FaReact />,
      point: <FaHandPointRight />,
      title: "Frontend",
      list: [
        "React",
        "React-Native",
        "PWA",
        "Redux",
        "Javascript",
        "HTML5, CSS3",
        "Tailwind, Material-UI, Bootstrap",
        "Next.js",
      ],
    },
    {
      id: 2,
      icon: <FaNodeJs />,
      point: <FaHandPointRight />,
      title: "Backend",
      list: ["Node.js/Express", "Ruby", "Ruby on rails", "Nest.js", "Next.js"],
    },
    {
      id: 3,
      icon: <FaDatabase />,
      point: <FaHandPointRight />,
      title: "Base de données et ORM",
      list: ["Postgres", "MySQL", "MongoDB", "Sequelize", "TypeORM", "Prisma"],
    },
    {
      id: 4,
      icon: <FaTools />,
      point: <FaHandPointRight />,
      title: "Outils",
      list: [
        "Postman",
        "Git, Github",
        "Webpack",
        "Heroku",
        "Digital Ocean",
        "Netlify",
        "Jest, Mocha, Chai",
      ],
    },
  ],
  contact: {
    title: "Contactez-moi",
    subTitle: "Entrons en contact",
    info: "Je suis toujours ouvert à de nouvelles opportunités et collaborations. Si vous avez des questions, N'hésitez pas à me contacter.",
    list: [
      {
        id: 1,
        icon: <FaMapMarkerAlt className="dark:text-blue-600" />,
        title: "Kigali - Rwanda",
      },
      {
        id: 2,
        icon: <FaEnvelope className="dark:text-blue-600" />,
        title: "mwafrikajosue@gmail.com",
      },
      {
        id: 3,
        icon: <FaPhoneAlt className="dark:text-blue-600" />,
        title: "(+243) 995220038",
      },
    ],
  },
  menu: [
    {
      id: 1,
      name: "Accueil",
      url: "/#home",
    },
    {
      id: 2,
      name: "À propos",
      url: "/#about",
    },
    {
      id: 3,
      name: "Projets",
      url: "/#projects",
    },
    {
      id: 4,
      name: "Technologies",
      url: "/#tech",
    },
    {
      id: 5,
      name: "Contact",
      url: "/#contact",
    },
  ],
};

export default data;
